import { IconButton, Stack, SwipeableDrawer, Typography } from '@mui/material';
import HorizontalLogo from 'components/horizontal-logo/horizontal-logo.component';
import { useTranslation } from 'react-i18next';
import * as S from './header-drawer.styles';

const HeaderDrawer = ({ children, isLight, onClose, title, ...rest }) => {
  const { t } = useTranslation();

  return (
    <SwipeableDrawer
      anchor="right"
      onClose={onClose}
      PaperProps={{
        'data-testid': 'Drawer.SwipeableDrawer',
        role: 'dialog',
        'aria-modal': 'true',
        'aria-labelledby': 'header-drawer-title',
      }}
      ModalProps={{
        keepMounted: false,
      }}
      {...rest}
    >
      <S.InnerContainer className={isLight ? 'light' : null}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Stack direction="row" alignItems="center" spacing={1}>
            <HorizontalLogo />
            <Typography variant="h6" component="h2" id="header-drawer-title">
              {title}
            </Typography>
          </Stack>
          <IconButton
            onClick={onClose}
            aria-label={t('drawer.closeIcon.ariaLabel')}
            data-testid="Drawer.IconButton.Close"
          >
            <S.Close />
          </IconButton>
        </Stack>
        {children}
      </S.InnerContainer>
    </SwipeableDrawer>
  );
};

export default HeaderDrawer;
